export const housingStatusKeys = {
  all: ['housing-statuses'],
  list: (params: any) => ['housing-statuses', 'list', params],
  detail: (id: any) => ['housing-statuses', 'detail', id],
};
